import {Button, Dropdown, MenuProps, Space, Typography} from "antd";
import {DownOutlined} from "@ant-design/icons";
import useTableData from "../tableContext/useTableData";
import {useState} from "react";
import {filterTypeOptions} from "../tableTypes";

interface TableDropdownSelectorProps {
    type: string;
    filterKey: string;
}

const TableDropdownSelector = ({ type, filterKey }: TableDropdownSelectorProps) => {

    // in case of dropdown with options that should be loaded, to avoid race conditions we use filterBase to store changes in filters without re-loading the data on every change.
    const allKey = type === filterTypeOptions.textToId ? 0 : 'all';
    const { filtersBase, filters, setFilters } = useTableData();
    const filterBase = filtersBase.find(filter => filter.filterKey === filterKey);
    const dropdownOptions: MenuProps['items'] = [{ key: allKey, label: filterBase?.allLabel || 'All' }, ...(filterBase?.options || [])];
    const [selectedKey, setSelectedKey] = useState(allKey);
    const selectedItem = dropdownOptions.find(ddo => ddo && ddo['key'] === selectedKey);
    // @ts-ignore
    const label = selectedItem ? selectedItem['label'] : '';

    const onChange = (newKey: string) => {
        const newKeyNum = type === filterTypeOptions.textToId ? parseInt(newKey) : newKey.toString();
        setSelectedKey(newKeyNum);
        setFilters(filters.map(filter => {
            if (filter.filterKey === filterKey && filter.type === type) {
                if (newKeyNum === allKey) {
                    return {...filter, selected: null};
                } else {
                    return {...filter, selected: newKeyNum};
                }
            } else {
                return filter;
            }
        }));
    }

    return (
        <div className="table-dropdown-selector-container">
            <Dropdown
                overlayStyle={{ zIndex: 10050 }}
                getPopupContainer={(trigger) => trigger.parentElement || document.body}
                menu={{
                    items: dropdownOptions,
                    selectable: true,
                    selectedKeys: [selectedKey.toString()],
                    onClick: (event) => onChange(event.key),
                    className: 'table-dropdown-selector-menu'
                }}
            >
                <Button className="dropdown-button">
                    <Space>
                        {label}
                        <DownOutlined />
                    </Space>
                </Button>
            </Dropdown>
        </div>
    );
}

export default TableDropdownSelector;
